import cx from 'classnames';

import Face from '../Face';
import FlipButton from '../FlipButton';

import styles from './Back.module.less';

const Back = ({
  title,
  item,
  description,
  size = 'md',
  opened,
  handleFlip,
  columns,
  isEditMode,
}) => {
  const classes = cx(
    { [styles.opened]: opened, [styles.back]: !opened },
    styles[size],
    styles[`cols${columns}`],
  );

  return (
    <Face className={classes} item={item} isEditMode={isEditMode}>
      <FlipButton onClick={handleFlip} className={styles.flip} />
      <div className={styles.backcontent}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </Face>
  );
};

export default Back;
